import { render } from "./OurMission.vue?vue&type=template&id=676f206a&scoped=true"
import script from "./OurMission.vue?vue&type=script&lang=js"
export * from "./OurMission.vue?vue&type=script&lang=js"

import "./OurMission.vue?vue&type=style&index=0&id=676f206a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-676f206a"]])

export default __exports__